import { render, staticRenderFns } from "./LaStoria.vue?vue&type=template&id=64a11552&scoped=true&"
import script from "./LaStoria.vue?vue&type=script&lang=js&"
export * from "./LaStoria.vue?vue&type=script&lang=js&"
import style0 from "./LaStoria.vue?vue&type=style&index=0&id=64a11552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a11552",
  null
  
)

export default component.exports